import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext, useEffect, useState } from "react";
import type { ViewerSnapshot } from "../contracts";
import type { ViewerController } from "../viewer";
const ViewerContext = createContext<ViewerController | null>(null);
export interface ViewerProviderProps {
  viewer: ViewerController;
  children?: ReactNode;
}
export function ViewerProvider(t0) {
  const $ = _c(3);
  const {
    viewer,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== viewer) {
    t1 = <ViewerContext.Provider value={viewer}>{children}</ViewerContext.Provider>;
    $[0] = children;
    $[1] = viewer;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function useViewer() {
  const viewer = useContext(ViewerContext);
  if (!viewer) {
    throw new Error("useViewer must be used inside GraphCanvas or ViewerProvider");
  }
  return viewer;
}
export function useViewerState() {
  const $ = _c(5);
  const viewer = useViewer();
  let t0;
  if ($[0] !== viewer) {
    t0 = () => viewer.getSnapshot();
    $[0] = viewer;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [snapshot, setSnapshot] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== viewer) {
    t1 = () => {
      const update = () => setSnapshot(viewer.getSnapshot());
      const unsubscribers = [viewer.subscribe("graph", update), viewer.subscribe("selection", update), viewer.subscribe("hover", update), viewer.subscribe("viewport", update)];
      update();
      return () => {
        for (const unsubscribe of unsubscribers) {
          unsubscribe();
        }
      };
    };
    t2 = [viewer];
    $[2] = viewer;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return snapshot;
}
export { ViewerContext };